// extracted by mini-css-extract-plugin
module.exports = {"s6tdj7g":"s6tdj7g"};